<template>
    <form @submit.prevent="submitForm" class="login-form p-3 sm:py-9 sm:px-0 text-ma-gray-3 sm:text-ma-black-1">
        <Message
            v-if="styledError"
            class="mb-3"
            :message="styledError"
        />

        <Message
            v-if="message"
            class="mb-3"
            level="success"
            :message="message"
        />

        <ul class="pb-9" v-if="showForm">
            <li class="text-left">
                <label for="reset-email" class="uppercase sm:text-ma-black-1 font-bold block mb-1">Email</label>
                <input id="reset-email" type="text" v-model="email" name="email" class="w-full p-2 ma-black-1" />
            </li>

            <li class="text-center mt-8">
                <button
                    type="submit"
                    class="font-semibold ma-btn ma-btn--blue w-full sm:w-48 p-2"
                    :class="{ 'opacity-25': loading || !email }"
                    :disabled="loading || !email"
                >
                    <div class="animation-spin btn-spinner inline-block mr-2" v-show="loading" v-cloak>
                        <i class="icon-spinner2"></i>
                    </div>
                    Reset Password
                </button>
            </li>

            <li class="text-center mt-9 sm:mb-0 text-sm">
                Back to <router-link to="/account/login" class="text-ma-blue-1 hover:text-ma-blue-0 font-semibold">login</router-link>
            </li>
        </ul>

    </form>
</template>

<script>
    import axios from 'axios';
    import Message from '@/components/Message';

    export default {
        components: {
            Message
        },

        data: () => ({
            message: '',
            error: '',
            email: '',
            loading: false,
            showForm: true
        }),

        computed: {
            styledError() {
                // "e-mail address" stays in a single line.
                return this.error.replace(/(e\-mail address\.)/, '<span class="whitespace-no-wrap">$1</span>')
            }
        },

        methods: {
            async submitForm() {
                this.loading = true;

                // Reset success and error messages
                this.error = '';
                this.message = '';

                try {
                    let response = await axios.post('/account/password/remind', { email: this.email });

                    this.message = response.data.message;

                    this.showForm = false;
                } catch (e) {
                    this.error = e.response.data.message;
                }

                this.loading = false;
            }
        }
    }
</script>
